import { FC } from 'react';
import { navigate } from 'gatsby';
import { Rating } from '@mui/material';
import * as Yup from 'yup';
import { ButtonOutlinePrimary, Form, Icon, InputTextarea } from '@lambdacurry/component-library';
import { useCreateCancellationFeedbackMutation } from 'lib/home/generated/queries';
import { CancelPlanReasonFormValues } from '../CancelPlanReasonForm';

export interface CancelledPlanRatingFormValues {
  rating: number;
  final_notes?: string;
}

export const CancelledPlanRatingForm: FC<{ cancellation: CancelPlanReasonFormValues }> = ({ cancellation }) => {
  const { mutate } = useCreateCancellationFeedbackMutation();
  const handleSubmit = (values: CancelledPlanRatingFormValues) =>
    mutate({ input: { ...values, ...cancellation } }, { onSuccess: () => navigate('/') });

  return (
    <Form<CancelledPlanRatingFormValues>
      initialValues={{ rating: 0, final_notes: '' }}
      onSubmit={handleSubmit}
      validationSchema={Yup.object().shape({
        rating: Yup.number().required('Please enter a valid rating').typeError('Please enter a valid rating'),
        final_notes: Yup.string()
      })}
    >
      {formikProps => (
        <>
          <Rating
            icon={<Icon className="!h-10 !w-10" name="starFilled" />}
            emptyIcon={<Icon className="!h-10 !w-10" name="starEmpty" />}
            name="rating"
            value={formikProps.values.rating}
            onChange={(e, value) => formikProps.setFieldValue('rating', value)}
          />
          <InputTextarea
            className="my-0"
            name="final_notes"
            placeholder="Please enter your feedback here..."
            formikProps={formikProps}
          />

          <ButtonOutlinePrimary className="mt-6 w-full md:w-56" type="submit">
            Send Feedback
          </ButtonOutlinePrimary>
        </>
      )}
    </Form>
  );
};
